import { render } from "./StoresSelector.vue?vue&type=template&id=1882231b"
import script from "./StoresSelector.vue?vue&type=script&lang=js"
export * from "./StoresSelector.vue?vue&type=script&lang=js"

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__